import { FirmRecord } from '@tassat/fred-definitions';

import { Firms } from './firms';

export interface GridFirmData extends FirmRecord {
    HasApiConnections?: boolean;
}

export default Firms;